import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Video.css';
import moment from 'moment';
import VideoModal from 'components/shared/modal/VideoModal';

class Video extends Component {
  static propTypes = {
    video: PropTypes.shape().isRequired,
  };

  constructor(props) {
    super(props);

    this.state = { showVideoModal: false };
  }

  toggleVideoModal = () => {
    const { showVideoModal } = this.state;
    this.setState({ showVideoModal: !showVideoModal });
  };

  render() {
    const { video } = this.props;
    const { showVideoModal } = this.state;
    return (
      <div className="video">
        <div className="video-preview" onClick={this.toggleVideoModal}>
          <img src={video.video.thumb.url} alt="Video Preview" />
          <div className="video-overlay">
            {moment.utc(video.duration * 1000).format('m:ss')}
          </div>
        </div>
        {showVideoModal && (
          <VideoModal
            autoPlay={true}
            show={showVideoModal}
            videoSrc={video.video.url}
            onHide={this.toggleVideoModal}
          />
        )}
      </div>
    );
  }
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/shared/video/Video.js